var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"view-title"},[_vm._v("新增作者")]),_c('div',{staticClass:"wrapper"},[_c('el-row',[_c('el-col',{attrs:{"lg":16,"md":20,"sm":24,"xs":24}},[_c('author-info')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }